<template>
  <div
    id="app"
    :class="{ 'main-page': true, 'pb-0': $route.name == 'corridor2' }"
  >
    <div class="loader-line" v-if="$store.state.loading"></div>
    <sidebar-comp />
    <div
      :class="{
        'd-flex': true,
        navbar: true,
        'justify-content-between': true,
        'align-items-start': true,
        'pt-md-3': true,
        'position-absolute': true,
        'd-none': this.$route.name == 'corridor2' || this.$route.name == 'report',
      }"
    >
      <div
        class="d-flex gap-2 align-items-center col-md-3 col-6 justify-content-start"
      >
        <img
          src="/assets/img/LogoIransafar.svg"
          alt="logo"
          class="header-logo"
        />
        <div class="text-center">
          <router-link to="/">
            <div class="f-15">ایران سفـر</div>
            <div class="text-gray f-11 fw-lighter">مشاور سفر آنلاین</div>
          </router-link>
        </div>
      </div>
      <div class="col-md-6 d-none d-md-block">
        <ul class="menu d-flex p-0 f-14 gap-2 justify-content-center">
          <li>
            <router-link
              to="/blog"
              :class="{
                'border-end': true,
                'link-active': this.$route.name == 'blog',
              }"
              >ایران گردی</router-link
            >
          </li>
          <li>
            <router-link
              to="/maps"
              :class="{
                'border-end': true,
                'link-active': this.$route.name == 'corridor2',
              }"
              >نقشه سفر</router-link
            >
          </li>
          <li>
            <router-link
              to="/Ticket"
              :class="{
                'border-end': true,
                'link-active': this.$route.name == 'Ticket',
              }"
            >
              بلیط
            </router-link>
          </li>
          <li>
            <router-link
              to="/residence"
              :class="{
                'border-end': true,
                'link-active': this.$route.name == 'residence',
              }"
            >
              اقامتگاه
            </router-link>
          </li>
           
          <li>
            <router-link
              to="/restaurant"
              :class="{
                'border-end': true,
                'link-active': this.$route.name == 'restaurant',
              }"
              >غذا</router-link
            >
          </li>
          <li>
            <router-link
              to="/tour"
              :class="{
                'border-end': true,
                'link-active': this.$route.name == 'tour',
              }"
              >تور</router-link
            >
          </li>
          <li>
            <router-link
              to="/TourismService"
              :class="{
                'border-end': false,
                'link-active': this.$route.name == 'TourismService',
              }"
            >
              خدمات گردشگری
            </router-link>
          </li>
         
          
          
        </ul>
      </div>

      <div class="col-md-3 col-6 text-end">
        <!--data-bs-toggle="modal"
          data-bs-target="#registerModal1"-->
        <button
          id="openRegLoginMoal"
          class="btn irsafar-btn"
          v-if="!$store.state.isLogin"
        >
          ورود / ثبت نام
        </button>
        <div class="dropdown d-inline-block user-btn-container" v-else>
          <button
            class="btn irsafar-btn user-btn dropdown-toggle d-flex align-items-center gap-2 px-2"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <div class="small-avatar">
              <img src="/assets/img/user-avatar.png" alt="" />
            </div>
            <div class="col-8 p-0 f-11 three-dots h-unset text-start">
              {{
                this.$store.state.userData &&
                this.$store.state.userData.personnel
                  ? this.$store.state.userData.personnel.name
                  : ""
              }}
              {{
                this.$store.state.userData &&
                this.$store.state.userData.personnel
                  ? this.$store.state.userData.personnel.family
                  : ""
              }}
            </div>
          </button>
          <ul
            class="dropdown-menu end-0 start-unset f-12 w-100 mt-0 px-2"
            aria-labelledby="dropdownMenuButton1"
          >
            <li>
              <router-link class="dropdown-item" to="/profile/dashboard"
                >پیشخوان</router-link
              >
            </li>
            <li>
              <router-link class="dropdown-item" to="/profile/messages"
                >پیام ها</router-link
              >
            </li>
            <li>
              <router-link class="dropdown-item" to="/profile/wallet"
                >کیف پول</router-link
              >
            </li>
            <li>
              <router-link class="dropdown-item" to="/profile/transaction"
                >لیست تراکنش ها</router-link
              >
            </li>
            <li>
              <router-link class="dropdown-item" to="#"
                >سفارشات رستوران</router-link
              >
            </li>
            <li>
              <router-link class="dropdown-item" to="#"
                >رزرو تور و اقامتگاه</router-link
              >
            </li>
            <li>
              <router-link class="dropdown-item" to="/profile/favorite"
                >علاقه مندی ها</router-link
              >
            </li>
            <li>
              <router-link class="dropdown-item" to="/profile/gifts"
                >تخفیف ها و جوایز</router-link
              >
            </li>
            <li>
              <router-link class="dropdown-item" to="/profile/invite"
                >دعوت از دوستان</router-link
              >
            </li>
            <li>
              <router-link class="dropdown-item" to="/profile/account"
                >جزئیات حساب کاربری</router-link
              >
            </li>
            <li>
              <span
                class="dropdown-item cursor-pointer"
                @click="$store.dispatch('logOut')"
                >خروج</span
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="roMain">
      <router-view />
    </div>

    <footer :class="{ 'd-none': isCorridor || isCorridor2 || this.$route.name == 'report' }">
      <div
        class="d-md-flex d-none gap-2 align-items-center justify-content-start footer-logo"
      >
        <img src="/assets/img/LogoIransafar.svg" alt="logo" />
        <div class="text-center">
          <div class="f-15">ایران سفـر</div>
          <div class="text-gray f-11 fw-lighter mt-1">مشاور سفر آنلاین</div>
        </div>
      </div>

      <div
        class="row footer-content m-0 col-10 m-auto justify-content-between border-bottom pb-3"
      >
        <div class="col-md-5 mb-md-0 mb-3">
          <div class="footer-title">درباره ما</div>
          ایران سفر یک همراه و همسفر رایگان و جامع است که سعی دارد تا دغدغه های
          یک سفر را به حداقل رسانده و سفری خاطره انگیز را برای همراهان خود به
          ارمغان آورد. نقشه گردشگری وبسایت ایران سفر در کنار دیگر امکانات و
          فناوری های کارآمد آن، بخش کوچکی از خدمات این وبسایت فوق العاده می باشد
          که آن را به یکی از بهترین پلتفرم های گردشگری تبدیل کرده است.
          <div class="d-flex">
            <a
              referrerpolicy="origin"
              target="_blank"
              class="d-block mt-3"
              href="https://trustseal.enamad.ir/?id=294755&amp;Code=69CvLzbeTFE38zcnidMX"
              ><!--<img
              referrerpolicy="origin"
              src="https://Trustseal.eNamad.ir/logo.aspx?id=294755&amp;Code=69CvLzbeTFE38zcnidMX"
              alt=""
              style="cursor: pointer"
              id="69CvLzbeTFE38zcnidMX"
          />-->
              <img
                referrerpolicy="origin"
                src="/assets/img/enamad-logo.png"
                alt=""
                width="100"
                id="69CvLzbeTFE38zcnidMX"
              />
            </a>
            <div class="mt-3" style="margin-right: 0.5rem">
              <img
                style="width: 150px"
                src="/assets/img/gardeshgari.png"
                alt=""
              />
            </div>
          </div>
        </div>
        <div class="col-md-auto col-6 mb-md-0 mb-3">
          <div class="footer-title">راهنمایی</div>
          <ul class="footer-link">
            <li><router-link to="/about">درباره ما</router-link></li>
            <li><router-link to="/contact">تماس با ما</router-link></li>
            <li>
              <router-link to="/customer-club">باشگاه مشتریان</router-link>
            </li>
          </ul>
        </div>
        <div class="col-md-auto col-6 mb-md-0 mb-3">
          <div class="footer-title">لینک های مفید</div>
          <ul class="footer-link">
            <li>
              <router-link
                to="/residence"
                :class="{
                  'link-active': this.$route.name == 'residence',
                }"
              >
                اقامتگاه
              </router-link>
            </li>
            <li>
              <router-link
                to="/restaurant"
                :class="{
                  'link-active': this.$route.name == 'restaurant',
                }"
                >غذا</router-link
              >
            </li>
            <li>
              <router-link
                to="/corridor"
                :class="{
                  'link-active': this.$route.name == 'corridor',
                }"
                >نقشه سفر</router-link
              >
            </li>
            <li>
              <router-link
                to="/tour"
                :class="{
                  'link-active': this.$route.name == 'tour',
                }"
                >تور</router-link
              >
            </li>
            <li>
              <router-link
                to="/blog"
                :class="{
                  'link-active': this.$route.name == 'blog',
                }"
                >ایران گردی</router-link
              >
            </li>
          </ul>
        </div>
        <div class="col-md-auto col-6 mb-md-0 mb-3"></div>
        <div class="col-md-10 mx-auto footer-info">
          <div class="d-md-block d-none">
            نظرات، پیشنهادات و انتقادات خود را با ما در میان بگذارید.
          </div>
          <div class="d-md-flex d-none gap-1 align-items-center">
            <LocationIcon />
            <div>
              تهران - خیابان ولی عصر (عج)، خیابان توانیر، خیابان نظامی گنجوی
            </div>
          </div>
          <div class="d-flex gap-1 align-items-center">
            <span>info@iransafar.com</span>
            <MailIcon />
          </div>
          <div class="d-flex gap-1 align-items-center">
            <span>021-88678946-9</span>
            <TelephoneIcon />
          </div>
        </div>
      </div>
      <div class="copyright-container pb-md-2 pb-3">
        تمام حقوق مادی و معنوی این سایت متعلق به ایران سفر است.
      </div>
    </footer>

    <!--Register modal-->
    <div
      class="modal fade"
      id="registerModal1"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content form-container bg-lightblue">
          <div class="modal-body m-0">
            <div class="row p-2">
              <div class="col-5 my-auto my-md-4">
                <img src="/assets/img/modalPic.png" />
              </div>
              <div class="col-7 card-container">
                <div class="text-end p-2 f-14 text-green">
                  <span data-bs-dismiss="modal" class="cursor-pointer"
                    >&#10006;</span
                  >
                </div>
                <div class="text-center row pt-md-5">
                  <div class="pb-md-2">
                    <img src="assets/img/LogoIransafar.png" />
                  </div>
                  <div class="f-14 py-2 col-md-9 mx-auto text-gray2">
                    برای ورود یا ثبت نام شماره موبایل خود را وارد کنید
                  </div>
                  <div
                    class="mx-auto py-2 col-md-7 mx-auto"
                    v-if="!sendCheckExistLoading"
                  >
                    <input
                      class="w-100 popup"
                      type="text"
                      id="registerMobile"
                      placeholder="0912XXXXXXX"
                      maxlength="11"
                      v-model="mobile"
                    />
                    <button
                      class="btn bg-orange f-12 mt-3 text-gray2 w-100"
                      type="button"
                      id="regModal2"
                    >
                      ادامه
                    </button>
                  </div>
                  <div v-else class="text-center p-3">
                    <img src="/assets/img/ladng-circle.gif" alt="" width="50" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="loginModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content form-container bg-lightblue">
          <div class="modal-body m-0">
            <div class="row p-2">
              <div class="col-5 my-auto my-md-4">
                <img src="/assets/img/modalPic.png" />
              </div>
              <div class="col-7 card-container">
                <div class="text-end p-2 f-14 text-green">
                  <span data-bs-dismiss="modal" class="cursor-pointer"
                    >&#10006;</span
                  >
                </div>
                <div class="row pt-md-1 ps-5">
                  <div class="pb-md-2 text-center">
                    <img src="assets/img/LogoIransafar.png" />
                  </div>
                  <div class="col-md-9">
                    <label class="f-14 py-2 text-gray2 fw-bold"
                      >شماره موبایل</label
                    >
                    <input
                      class="w-100 popup my-1"
                      type="text"
                      v-model="mobile"
                      maxlength="11"
                      readonly
                    />
                    <label class="f-14 py-2 text-gray2 fw-bold"
                      >رمز عبور
                    </label>
                    <input
                      class="w-100 popup my-1"
                      type="password"
                      v-model="loginPass"
                    />
                    <button
                      class="btn bg-orange f-12 mt-3 text-gray2 w-100"
                      type="button"
                      @click="login"
                    >
                      ورود
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="registerModal2"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content form-container bg-lightblue">
          <div class="modal-body m-0">
            <div class="row p-2">
              <div class="col-5 my-auto my-md-4">
                <img src="/assets/img/modalPic.png" />
              </div>
              <div class="col-7 card-container">
                <div class="text-end p-2 f-14 text-green">
                  <span data-bs-dismiss="modal" class="cursor-pointer"
                    >&#10006;</span
                  >
                </div>
                <div class="text-center row pt-md-5">
                  <div class="pb-md-2">
                    <img src="assets/img/LogoIransafar.png" />
                  </div>
                  <div class="f-14 py-2 col-md-9 mx-auto text-gray2">
                    کد ارسال شده به شماره تماس {{ mobile }} را وارد کنید
                  </div>
                  <div class="mx-auto py-2 col-md-7 mx-auto">
                    <div class="row conf-code mt-3 flex-row-reverse">
                      <div class="col-3">
                        <input
                          name="code"
                          class="code-input form-control form-control-sm w-100 popup"
                          required
                        />
                      </div>
                      <div class="col-3">
                        <input
                          name="code"
                          class="code-input form-control form-control-sm w-100 popup"
                          required
                        />
                      </div>
                      <div class="col-3">
                        <input
                          name="code"
                          class="code-input form-control form-control-sm w-100 popup"
                          required
                        />
                      </div>
                      <div class="col-3">
                        <input
                          name="code"
                          class="code-input form-control form-control-sm w-100 popup"
                          id="lastNumber"
                          required
                        />
                      </div>
                    </div>
                    <button
                      class="btn bg-transparent shadow-none text-blue mt-3 f-12"
                      id="resendCode"
                    >
                      ارسال مجدد کد
                      <span class="js-timeout"></span>
                    </button>
                    <!--  <input
                      class="w-100 popup"
                      type="text"
                      v-model="otp"
                      maxlength="11"
                    />
                    <button
                      class="btn bg-orange f-12 mt-3 text-gray2 w-100"
                      type="button"
                      id="regModal3"
                      data-toggle="modal"
                      data-target="#registerModal3"
                    >
                      ادامه
                    </button>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--MODAL-->
    <div
      class="modal fade"
      id="registerModal3"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content form-container bg-lightblue">
          <div class="modal-body m-0">
            <div class="row p-2">
              <div class="col-5 my-auto my-md-4">
                <img src="/assets/img/modalPic.png" />
              </div>
              <div class="col-7 card-container">
                <div class="text-end p-2 f-14 text-green">
                  <span data-bs-dismiss="modal" class="cursor-pointer"
                    >&#10006;</span
                  >
                </div>
                <div class="row pt-md-1 ps-5">
                  <div class="pb-md-2 text-center">
                    <img src="assets/img/LogoIransafar.png" />
                  </div>
                  <div class="col-md-9">
                    <label class="f-14 py-2 text-gray2 fw-bold">نام</label>
                    <input
                      class="w-100 popup my-1"
                      type="text"
                      v-model="name"
                    />
                    <label class="f-14 py-2 text-gray2 fw-bold"
                      >نام خانوادگی
                    </label>
                    <input
                      class="w-100 popup my-1"
                      type="text"
                      v-model="family"
                    />
                    <button
                      class="btn bg-orange f-12 mt-3 text-gray2 w-100"
                      type="button"
                      id="regModal4"
                      data-toggle="modal"
                      data-target="#registerModal4"
                    >
                      ادامه
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--MODAL-->
    <div
      class="modal fade"
      id="registerModal4"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content form-container bg-lightblue">
          <div class="modal-body m-0">
            <div class="row p-2">
              <div class="col-5 my-auto my-md-4">
                <img src="/assets/img/modalPic.png" />
              </div>
              <div class="col-7 card-container">
                <div class="text-end p-2 f-14 text-green">
                  <span data-bs-dismiss="modal" class="cursor-pointer"
                    >&#10006;</span
                  >
                </div>
                <div class="row pt-md-1 ps-5">
                  <div class="pb-md-2 text-center">
                    <img src="assets/img/LogoIransafar.png" />
                  </div>
                  <div class="col-md-9">
                    <label class="f-14 py-2 text-gray2 fw-bold">رمز عبور</label>
                    <input
                      class="w-100 popup my-1"
                      type="password"
                      v-model="password"
                    />
                    <label class="f-14 py-2 text-gray2 fw-bold"
                      >تکرار رمز عبور</label
                    >
                    <input
                      class="w-100 popup my-1 confPass"
                      type="password"
                      v-model="confPass"
                    />
                    <button
                      class="btn bg-orange f-12 mt-3 text-gray2 w-100"
                      type="button"
                      id="regModal5"
                    >
                      ثبت نام
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <notifications group="foo" position="bottom right" class="text-start" />
  </div>
</template>
<script>
import LocationIcon from "@/assets/svg/LocationIcon.svg";
import MailIcon from "@/assets/svg/MailIcon.svg";
import TelephoneIcon from "@/assets/svg/TelephoneIcon.svg";
import SidebarComp from "./components/SidebarComp.vue";

export default {
  name: "App",
  data() {
    return {
      mobile: "",
      username: "",
      otp: "",
      name: "",
      family: "",
      password: "",
      loginPass: "",
      confPass: "",
      sendCheckExistLoading: false,
    };
  },
  computed: {
    isCorridor() {
      return this.$route.fullPath == "/corridor";
    },
    isCorridor2() {
      return this.$route.fullPath == "/maps";
    },
  },
  methods: {
    async register() {
      this.$store.state.loading = true;
      try {
        const { data } = await this.$https.post(`/user/api/register_otp`, {
          name: this.name,
          family: this.family,
          otp: this.otp,
          type: "mobile",
          password: this.password,
          mobile: this.mobile,
          sex: 1,
        });

        console.log(data);
        localStorage.setItem("accessToken", data.accessToken);
        this.$notify({
          group: "foo",
          type: "success",
          text: "ثبت نام با موفقیت انجام شد",
        });

        this.$store.state.isLogin = true;
        this.$store.state.userData = data.userData;
        this.$store.state.loading = false;
        // try {
        //   const { data } = await this.$https.get(`/user/api/user`, {
        //     headers: {
        //       Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        //     },
        //   });

        //   console.log(data);
        //   this.$store.state.userData = data.data;
        //   this.$store.state.loading = false;
        // } catch (errors) {
        //   console.error(errors);
        //   this.$store.state.loading = false;
        // }
      } catch (errors) {
        console.error(errors);
        this.$store.state.loading = false;
      }
    },
    async login() {
      try {
        const { data } = await this.$https.post(`/user/api/login`, {
          username: this.mobile,
          password: this.loginPass,
        });

        console.log(data);
        if (data.ok) {
          localStorage.setItem("accessToken", data.accessToken);

          this.$store.state.userData = data.userData;
          this.$store.state.loading = false;
          this.$store.state.isLogin = true;
          this.$notify({
            group: "foo",
            type: "success",
            text: "خوش آمدید",
          });
          $("#loginModal").modal("hide");
          if (window.afterLoginCallback) {
            window.afterLoginCallback();
          }
        } else {
          this.$notify({
            group: "foo",
            type: "error",
            text: data.message,
          });
        }
      } catch (errors) {
        console.error(errors);
        this.$store.state.loading = false;
      }
    },
  },
  mounted() {
    $(".js___open_drawer").click(function () {
      $("#drawer-toggle-label").click();
    });
    $(".js__close_drawer").click(function () {
      $("#drawer-toggle-label").click();
    });
    const mainThis = this;
    var interval;

    function countdown() {
      clearInterval(interval);
      $(".js-timeout").text("2:00");
      interval = setInterval(function () {
        $("#resendCode").prop("disabled", true);

        var timer = $(".js-timeout").html();
        timer = timer.split(":");
        var minutes = timer[0];
        var seconds = timer[1];
        seconds -= 1;
        if (minutes < 0) return;
        else if (seconds < 0 && minutes != 0) {
          minutes -= 1;
          seconds = 59;
        } else if (seconds < 10 && length.seconds != 2) seconds = "0" + seconds;

        $(".js-timeout").html(minutes + ":" + seconds);

        if (minutes == 0 && seconds == 0) {
          $("#resendCode").prop("disabled", false);
          $(".js-timeout").text("");
          clearInterval(interval);
        }
      }, 1000);
    }

    $(document).on("click", "#openRegLoginMoal", async function () {
      mainThis.mobile = "";
      mainThis.username = "";
      mainThis.otp = "";
      mainThis.name = "";
      mainThis.family = "";
      mainThis.password = "";
      mainThis.loginPass = "";
      mainThis.confPass = "";
      $("#registerModal1").modal("toggle");
    });
    $(document).on("click", "#regModal2", async function () {
      if (mainThis.mobile.length == 0) {
        mainThis.$notify({
          group: "foo",
          type: "error",
          text: "شماره موبایل خود را وارد کنید",
        });
      } else {
        mainThis.$store.state.loading = true;
        mainThis.sendCheckExistLoading = true;
        try {
          const { data } = await mainThis.$https.post(
            `/userverification/api/send`,
            {
              mobile: mainThis.mobile,
              request_type: "sign",
              type: "mobile",
            }
          );

          console.log(data);
          $("#registerModal1").modal("hide");
          if (data.exists) {
            $("#loginModal").modal("toggle");
            mainThis.sendCheckExistLoading = false;
          } else {
            $("#registerModal2").modal("toggle");
            $(".js-timeout").text("2:00");
            countdown();
            mainThis.sendCheckExistLoading = false;
          }

          this.$notify({
            group: "foo",
            type: "success",
            text: "ثبت نام با موفقیت انجام شد",
          });
        } catch (errors) {
          console.error(errors);
          mainThis.$store.state.loading = false;
          mainThis.sendCheckExistLoading = false;
        }
      }
    });

    // $(document).on("click", "#regModal3", async function () {
    //   if (mainThis.otp.length == 0) {
    //     mainThis.$notify({
    //       group: "foo",
    //       type: "error",
    //       text: "کد ارسال شده را وارد کنید",
    //     });
    //   } else {
    //     mainThis.$store.state.loading = true;
    //     try {
    //       const { data } = await mainThis.$https.post(
    //         `http://iran-safar.com/userverification/api/validate`,
    //         {
    //           type: "mobile",
    //           mobile: mainThis.mobile,
    //           otp: mainThis.otp,
    //         }
    //       );

    //       console.log(data);
    //       if (data.ok) {
    //         $("#registerModal2").modal("hide");
    //         $("#registerModal3").modal("toggle");
    //       } else {
    //         mainThis.$notify({
    //           group: "foo",
    //           type: "error",
    //           text: "کد تایید یافت نشد.",
    //         });
    //       }

    //       mainThis.$store.state.loading = false;
    //     } catch (errors) {
    //       console.error(errors);
    //       mainThis.$store.state.loading = false;
    //     }
    //   }
    // });

    $(document).on("click", "#regModal4", function () {
      if (mainThis.name.length == 0 || mainThis.family.length == 0) {
        mainThis.$notify({
          group: "foo",
          type: "error",
          text: "فیلد هارا کامل کنید.",
        });
      } else {
        $("#registerModal3").modal("hide");
        $("#registerModal4").modal("toggle");
      }
    });
    $(document).on("click", "#regModal5", function () {
      if (mainThis.password != "" || mainThis.confPass != "") {
        if (mainThis.password == mainThis.confPass) {
          mainThis.register();
          $("#registerModal4").modal("hide");
        } else {
          mainThis.$notify({
            group: "foo",
            type: "error",
            text: "فیلد رمز عبور با تایید رمز عبور همخوانی ندارد.",
          });
        }
      } else {
        mainThis.$notify({
          group: "foo",
          type: "error",
          text: "فیلد هارا کامل کنید.",
        });
      }
    });

    $(document).on("click", "#resendCode", async function () {
      $(".js-timeout").text("2:00");
      countdown();

      mainThis.$store.state.loading = true;
      try {
        const { data } = await mainThis.$https.post(
          `/userverification/api/send`,
          {
            mobile: mainThis.mobile,
            request_type: "sign",
            type: "mobile",
          }
        );
        mainThis.$store.state.loading = false;
      } catch (errors) {
        console.error(errors);
        mainThis.$store.state.loading = false;
      }
    });

    const inputElements = [...document.querySelectorAll("input.code-input")];

    inputElements.forEach((ele, index) => {
      ele.addEventListener("keydown", async (e) => {
        if (e.keyCode === 8 && e.target.value === "")
          inputElements[Math.max(0, index - 1)].focus();
      });

      ele.addEventListener("input", async (e) => {
        const [first, ...rest] = e.target.value;
        e.target.value = first ?? "";
        const lastInputBox = index === inputElements.length - 1;
        const didInsertContent = first !== undefined;
        if (didInsertContent && !lastInputBox) {
          inputElements[index + 1].focus();
          inputElements[index + 1].value = rest.join("");
          inputElements[index + 1].dispatchEvent(new Event("input"));
        }

        if (ele.id == "lastNumber" && ele.value != "") {
          mainThis.$store.state.loading = true;
          const inputElements = [
            ...document.querySelectorAll("input.code-input"),
          ];
          var otpTmp = "";
          inputElements.forEach((ele, index) => {
            console.log(ele);
            otpTmp += ele.value;
          });
           
          mainThis.otp = otpTmp
          try {
            const { data } = await mainThis.$https.post(
              `http://iran-safar.com/userverification/api/validate`,
              {
                type: "mobile",
                mobile: mainThis.mobile,
                otp: mainThis.otp,
              }
            );
            console.log(data);
            if (data.ok) {
              $("#registerModal2").modal("hide");
              $("#registerModal3").modal("toggle");
            } else {
              mainThis.$notify({
                group: "foo",
                type: "error",
                text: "کد تایید یافت نشد.",
              });
            }
            mainThis.$store.state.loading = false;
          } catch (errors) {
            console.error(errors);
            mainThis.$store.state.loading = false;
          }
        }
      });
    });
    // $(document).on("keyup", "#lastNumber", async function () {
    //   const inputElements = [...document.querySelectorAll("input.code-input")];

    //   inputElements.forEach((ele, index) => {
    //     console.log(ele);
    //     // mainThis.otp = `${mainThis.otp}${e.target.value}`;
    //   });
    //   console.log(mainThis.otp);
    // mainThis.$store.state.loading = true;
    // try {
    //   const { data } = await mainThis.$https.post(
    //     `http://iran-safar.com/userverification/api/validate`,
    //     {
    //       type: "mobile",
    //       mobile: mainThis.mobile,
    //       otp: mainThis.otp,
    //     }
    //   );
    //   console.log(data);
    //   if (data.ok) {
    //     $("#registerModal2").modal("hide");
    //     $("#registerModal3").modal("toggle");
    //   } else {
    //     mainThis.$notify({
    //       group: "foo",
    //       type: "error",
    //       text: "کد تایید یافت نشد.",
    //     });
    //   }
    //   mainThis.$store.state.loading = false;
    // } catch (errors) {
    //   console.error(errors);
    //   mainThis.$store.state.loading = false;
    // }
    // });
  },
  async created() {
    if (localStorage.getItem("accessToken")) {
      this.$store.state.isLogin = true;
      this.$store.state.loading = true;
      try {
        const { data } = await this.$https.get(`/user/api/user`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        });

        console.log(data);
        this.$store.state.userData = data.data;
        this.$store.state.loading = false;
      } catch (errors) {
        console.error(errors);
        this.$store.state.loading = false;
      }
    }
  },
  components: { LocationIcon, MailIcon, TelephoneIcon, SidebarComp },
};
</script>
